import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { first } from 'rxjs';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';
declare var EXIF: any;

@Component({
  selector: 'app-course-attendance',
  templateUrl: './course-attendance.component.html',
  styleUrls: ['./course-attendance.component.scss']
})
export class CourseAttendanceComponent implements OnInit {

  MeetingOptions:any;
  participantsptions:any;
  // districts:any=['Salem','Karur','Namakkal','Trichy'];
  createmeetingform !:FormGroup;
  constituencies!:any;
  meeting_name: any;
  meeting_time: any;
  meeting_date: any;
  participants: any;
  meeting_type: any;
  meeting_location: any;
  spinner: boolean;
  hidden:boolean=true;
  dropdownList : string[]= [];
  dropdownSettings: IDropdownSettings = {};
   users: any = JSON.parse(localStorage.getItem('login_user_details'));
 
  selectedItems = [];
  
  dropDownForm: FormGroup;
  tableshow: boolean=false;
  isButtonDisabled :boolean=false;
  CM_id: any;
  editmeetingform !:FormGroup;
  da_district:string;
  district: any = this.ApiService.user_details.district;
  constituency: any = this.ApiService.constituency;
  courses: any;
  userDistrict: any = this.ApiService.user_details.district;
  userConstituency: any = this.ApiService.user_details.constituency;
  userId: any = this.ApiService.user_details.id;
  ob_data: any;
  mentor_data: any;
  no_of_student: any;
  student_list: any = [];
  student_lists: any = [];
  CM_no_of_students: any;



  onItemSelect(item: any) {
    this.student_lists.push(item);
  }
  onItemDeSelect(item: any) {
    this.student_lists = this.student_lists.map((e) => {
      if (e! == item) {
        return e;
      }
    })
  }
  onSelectAll(items: any) {
    this.student_lists = items;
  }
  onUnSelectAll() {
    this.student_lists = [];
  }


  constructor(private fb: FormBuilder,private ApiService: ApiServiceService,private router:Router,private spinnerService: NgxSpinnerService,
    public datepipe:DatePipe) {
    this.createmeetingform= this.fb.group({
      course_name: ['',[Validators.required, Validators.pattern('[A-Za-z ]{1,32}')]],
      district:[this.current_date,Validators.required ],
      constituency:[this.current_time,Validators.required],
      organizer:['',Validators.required],
      course_start_date:['',Validators.required],
      course_end_date: ['', Validators.required],
      course_start_time:['',Validators.required],
      course_end_time: ['', Validators.required],
      volunteer1:['',Validators.required],
      volunteer2: [''],
      user_id:[''],
      comments:[''],
      course_location:['',Validators.required],
      status:[''],
      image:['']
    });
    this.editformInitialize('false');
    this.district = JSON.parse(localStorage.getItem('user_district'));

  }


  dtOptions: DataTables.Settings = {};
  date:any;
  enableButton:Boolean;

  ngOnInit():void{
    const userCategory = localStorage.getItem('category');
  
    
    // this.createmeetingform.get('district').value(this.userDistrict);
    // this.createmeetingform.get('constituency').value(this.userConstituency);
      
    // Remove double quotation marks from userCategory
    const cleanedUserCategory = userCategory.replace(/"/g, '');
    
    if (cleanedUserCategory === 'OB') {
    
      this.isButtonDisabled = true;
    } else {
      
      this.isButtonDisabled = false;
    }
    this.date = new Date();
      this.ApiService.courseAssignedToMentor(this.users.first_name).subscribe((data: any) => {
     
       this.mentor_data = data;  
     })
  
    this.ApiService.getOBDetailsForDistrictOccurance().subscribe((data) => {
      this.ob_data = data;
    })
    
// document.write(today);
    this.customers=[];
    this.showSpinner();
    this.ApiService.getDistrictOccurance().subscribe((data:any) => {
      // Flag to track if any customer has a start date in the past
      this.enableButton = false; // Initially disable the button
      let currentDate = new Date(); // Get the current date
    
      // Check if any customer has a start date in the past
      if (data.some(customer => {
        let startDate = new Date(customer.start_date + 'T' + customer.start_time); // Combine start_date and start_time strings into a single Date object
        return currentDate.getTime() >= startDate.getTime(); // Return true if the start date is in the past
      })) {
        
        this.enableButton = true; // Enable the button if any customer has a start date in the past
      }
    
      this.customers = data;
      this.tableshow = true;
      
    });
  
     this.ApiService.getCourses().subscribe((data: any) => {
       this.courses = data;
    
      })

    // this.getdata();
    // this.ApiService.viewtableOB();
    // this.ApiService.viewtableDA();
    // this.ApiService.viewtableSA();
    // this.ApiService.viewtableOBapprove();
    // this.ApiService.viewtablemeeting();
    this.dtOptions = {
      pagingType: 'full_numbers',
      order: [2,'asc']
    };

    const all_districts = this.ApiService.meeting_districts;
    this.dropdownList = all_districts;
  
   
    this.selectedItems = [
      { }
    ];
    this.dropDownForm = this.fb.group({
      meeting_district: [this.selectedItems]
  });
  this.da_district=localStorage.getItem('user_district');
  }
  isStartDateInTheFuture(item: any): boolean {
    let startDate = new Date(item.start_date + 'T' + item.start_time); // Combine start_date and start_time strings into a single Date object
    let currentDate = new Date(); // Get the current date
    return currentDate.getTime() < startDate.getTime(); // Return true if the start date is in the future
  }

 
  //Default date time in form
  current_date:any;
  current_time;any;
  setCurrentdate(){
    this.current_date=this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.current_time=this.datepipe.transform(new Date(), 'HH:mm');
    this.createmeetingform.get('district').setValue(this.userDistrict);
    this.createmeetingform.get('constituency').setValue(this.userConstituency);
    this.createmeetingform.get('user_id').setValue(this.userId);
  }
  public showSpinner(): void {
    this.spinnerService.show();
    }

  customers:any=[];
  
 
  postdata(angForm1 : any) //angForm1
    {
    console.log(angForm1.value);

    this.ApiService.createDistrictOccurance(angForm1.value).pipe().subscribe(
      data => {
        console.log(data);
        this.spinnerService.hide();
        setTimeout(() => {
          Swal.fire({
            title: 'Course District Occurrence Created!',
            icon: 'success',
            confirmButtonText: 'OK',
            confirmButtonColor: '#015792',
            iconColor: '#015792'
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
            }
          });
        }, 100);
      },
      error => {
        console.log(error);
      }
    );
          }
    
          delete_CM(id: any) {
            Swal.fire({
              title: 'Are you sure?',
              text: 'You want to delete this District Occurrence?',
              icon: 'warning',
              showCancelButton: true,
              iconColor:'#015792',
    confirmButtonColor: '#015792',
              cancelButtonColor: '#e5183b',
              confirmButtonText: 'Yes, Delete it!',
            }).then((result) => {
              if (result.isConfirmed) {
                this.ApiService.deleteDistrictOccurance(id)
                  .subscribe(
                    data => {
                      window.location.reload();
                      Swal.fire('Deleted!', 'Course District Occurrence has been deleted successfully.', 'success');
                    },
                    error => {
                      console.log(error);
                    }
                  );
              }
            });
          }
          

    

  radiobutton(option:any){
    this.MeetingOptions=option;
  }
  Participants(a:any){
    this.participantsptions=a;
  }
  CM_course_name: any;
  CM_district: any;
  CM_constituency: any;
  CM_organizer: any;
  CM_startDate: any;
  CM_endDate: any;
  CM_startTime: any;
  CM_endTime: any;
  CM_volunteer1: any;
  CM_volunteer2: any;
  CM_location: any;
  CM_status: any;
  CM_comments: any;
  student_names: any;
  uploadFiles: any = [];
  CM_course_id: any;
  allMetaData: any = [];
  CM_course_image:any;
  minDate: string;
  maxDate: string;
   selectFiles(event:any) {
     EXIF.getData(event.target.files[0], function () {
       this.allMetaData = EXIF.getAllTags(this);
       if (Object.keys(this.allMetaData).length === 0) {
        Swal.fire({
  icon: "error",
  title: "No Data Available. Please upload Geo Tag Image",

        });
          $('#file').val('');
       } else {
         
          if (event.target.files[0].size < 60000) {
    if (this.uploadFiles.length < 5) {
      $('#title').css('display', 'block');
      this.spinner = true;
      
      const formData: FormData = new FormData();
      formData.append('file', event.target.files[0]);
      this.ApiService.uploadActivityFile(formData).subscribe((da: any) => {
        this.uploadFiles.push(da);
        this.spinner = false;
        $('#list').append(`<label class="form-label">${event.target.files[0].name}</label><br/>`)
      })
    } else {
        Swal.fire({
  icon: "error",
  title: "The file upload should be 5 or less than 5",

});
      
    }
          } else {
              Swal.fire({
  icon: "error",
  title: "The size should be less than 60kb",

});
    
      $('#file').val('');
    }
         
       }
    });
   
    
  }



  editfield:boolean=false;
  buttonviewmeeting(a:any,editbutton:any ){
    
    this.ApiService.CourseStudentEnrolled(a.course_id).subscribe((data: any) => {
      if (data.length > 0) {
        this.student_list = data;
        this.no_of_student = data.length;
        let students = data.map((e) => e.name);
        this.student_names = students;
        this.editmeetingform.get('no_of_students').setValue(this.no_of_student);
      }
     })
    if (editbutton == 'edit') {
      this.editfield = true;
    } else {
      this.editfield = false;
    }
      this.CM_course_name=a.course_name;
          this.CM_district=a.district;
          this.CM_constituency=a.constituency;
    this.CM_startDate = a.start_date;
    this.CM_organizer = a.organizer;
          this.CM_endDate=a.end_date;
          this.CM_startTime=a.start_time;
          this.CM_endTime=a.end_time;
          this.CM_volunteer1=a.volunteer1;
    this.CM_volunteer2 = a.volunteer2;
    this.CM_location = a.location;
    this.CM_status = a.status;
    this.CM_comments = a.comments;
    this.CM_course_id = a.course_id;
    this.CM_course_image=a.image;
    this.CM_no_of_students=a.no_of_students;
    this.CM_id = a.id;
    this.editmeetingform.get('comments').setValue(a.comments);
    this.editmeetingform.get('course_name').setValue(a.course_name);
    this.editmeetingform.get('organizer').setValue(a.organizer);
      
          //this.editformInitialize(false);
      
   
    // this.editmeetingform.get('meeting_date').setValue(a.date);
    // this.editmeetingform.get('meeting_time').setValue(a.time);
          //this.editmeetingform.controls['meeting_date'].disable();
        //  this.editmeetingform.controls['meeting_date'].setValue(this.CM_date);
        //  this.editmeetingform.controls['meeting_date'].setValue(this.CM_time);

    }

          editformInitialize(a){
            this.editmeetingform= this.fb.group({
           course_name: ['',[Validators.required, Validators.pattern('[A-Za-z ]{1,32}')]],
      district:[this.current_date,Validators.required ],
      constituency:[this.current_time,Validators.required],
      organizer:['',Validators.required],
      course_start_date:['',Validators.required],
      course_end_date: ['', Validators.required],
      course_start_time:['',Validators.required],
      course_end_time: ['', Validators.required],
      volunteer1:['',Validators.required],
      volunteer2: [''],
      user_id:[''],
      comments:[''],
      course_location:['',Validators.required],
              status: [''],
              day_of_course: [''],
              date_of_course: [(new Date()).toISOString().substring(0, 10)],
              no_of_students: [''],
              photos: [''],
              image:['']

             
          });
          const today = new Date();
          this.minDate = this.formatDate(today);
          this.maxDate = this.formatDate(today);
          }
        
          private formatDate(date: Date): string {
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const day = date.getDate();
            return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
          }

          updatedata(updateform, id) {
            this.spinner = true;
            let values = updateform.value;
            values['images'] = this.uploadFiles;
            values['course_id'] = this.CM_course_id;
            values['students_attendance'] = this.student_lists;
            this.ApiService.CourseAttendance(values).subscribe(
              data => {
                this.spinnerService.hide();
                setTimeout(() => {
                  if (data && data.hasOwnProperty('error')) {
                    Swal.fire({
                      title: "Attendance for this course already submitted!",
                      icon: "warning",
                      iconColor: '#015792', 
                      confirmButtonColor: '#015792',
                      confirmButtonText: "Okay",
                    });
                  } else {
                    Swal.fire({
                      title: "Your Course Attendance created Successfully!",
                      icon: "success",
                  confirmButtonText: "Okay",
                  confirmButtonColor: '#015792',
                  iconColor: '#015792', 
                    }).then((result) => {
                      if (result.isConfirmed) {
                        window.location.reload();
                      }
                    });
                   
                  }
                }, 100);
              },
              error => {
                console.log(error);
              }
            );
          }
          
        

//           updatedata(updateform,id){
//             this.spinner = true;
//             let values = updateform.value;
//             values['images'] = this.uploadFiles;
//             values['course_id'] = this.CM_course_id;
//             values['students_attendance'] = this.student_lists;
//             this.ApiService.CourseAttendance(values).pipe().subscribe(
//               data => {
//                 this.spinnerService.hide();
//                     setTimeout(function () {
//                                   Swal.fire({
//   title: "Your Course Attendance created Successfully!",
//    icon: "success",
//                   confirmButtonText: "Okay",
//    confirmButtonColor: 'green',

// }).then((result) => {
//   /* Read more about isConfirmed, isDenied below */
//   if (result.isConfirmed) {
//     window.location.reload();
//   } 
// });
//                     }, 100)
//                 },
              
//               error => {
//                 console.log(error);
//               });
//           }

//reset form values in createform
  Formreset(){
    this.createmeetingform.reset();
    this.hidden=true;
    this.MeetingOptions='';
    //this.participantsptions='';
}


}
